import _classCallCheck from "/builds/www/u-design/u-design/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/www/u-design/u-design/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/builds/www/u-design/u-design/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/builds/www/u-design/u-design/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/builds/www/u-design/u-design/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/builds/www/u-design/u-design/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { IdentifierRole, isTopLevelDeclaration } from "../parser/tokenizer";
import Transformer from "./Transformer";

var ReactHotLoaderTransformer = /*#__PURE__*/function (_Transformer) {
  _inherits(ReactHotLoaderTransformer, _Transformer);

  var _super = _createSuper(ReactHotLoaderTransformer);

  function ReactHotLoaderTransformer(tokens, filePath) {
    var _this;

    _classCallCheck(this, ReactHotLoaderTransformer);

    _this = _super.call(this);
    _this.tokens = tokens;
    _this.filePath = filePath;

    ReactHotLoaderTransformer.prototype.__init.call(_assertThisInitialized(_this));

    ;
    return _this;
  }

  _createClass(ReactHotLoaderTransformer, [{
    key: "__init",
    value: function __init() {
      this.extractedDefaultExportName = null;
    }
  }, {
    key: "setExtractedDefaultExportName",
    value: function setExtractedDefaultExportName(extractedDefaultExportName) {
      this.extractedDefaultExportName = extractedDefaultExportName;
    }
  }, {
    key: "getPrefixCode",
    value: function getPrefixCode() {
      return "\n      (function () {\n        var enterModule = require('react-hot-loader').enterModule;\n        enterModule && enterModule(module);\n      })();".replace(/\s+/g, " ").trim();
    }
  }, {
    key: "getSuffixCode",
    value: function getSuffixCode() {
      var _this2 = this;

      var topLevelNames = new Set();

      var _iterator = _createForOfIteratorHelper(this.tokens.tokens),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var token = _step.value;

          if (!token.isType && isTopLevelDeclaration(token) && token.identifierRole !== IdentifierRole.ImportDeclaration) {
            topLevelNames.add(this.tokens.identifierNameForToken(token));
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var namesToRegister = Array.from(topLevelNames).map(function (name) {
        return {
          variableName: name,
          uniqueLocalName: name
        };
      });

      if (this.extractedDefaultExportName) {
        namesToRegister.push({
          variableName: this.extractedDefaultExportName,
          uniqueLocalName: "default"
        });
      }

      return "\n;(function () {\n  var reactHotLoader = require('react-hot-loader').default;\n  var leaveModule = require('react-hot-loader').leaveModule;\n  if (!reactHotLoader) {\n    return;\n  }\n".concat(namesToRegister.map(function (_ref) {
        var variableName = _ref.variableName,
            uniqueLocalName = _ref.uniqueLocalName;
        return "  reactHotLoader.register(".concat(variableName, ", \"").concat(uniqueLocalName, "\", ").concat(JSON.stringify(_this2.filePath || ""), ");");
      }).join("\n"), "\n  leaveModule(module);\n})();");
    }
  }, {
    key: "process",
    value: function process() {
      return false;
    }
  }]);

  return ReactHotLoaderTransformer;
}(Transformer);

export { ReactHotLoaderTransformer as default };